<div class="av-metric-card__head">
  <h2 class="av-metric-label m-0">{{ 'app.reports.monitoring.decisionTime.title' | translate }}</h2>
  <av-status-pill
    class="av-metric-card__chip"
    variant="muted"
    icon="calendar_month"
    [label]="monthName()"
  />
</div>
<div class="av-metric-card__figure av-metric-card__figure--trend">
  <p class="av-metric-value av-metric-value--duration m-0">
    @for (part of parts(); track part.unitKey) {
      <span class="av-value-text"
        >{{ part.value | number: '1.0-0' : language()
        }}<span class="av-metric-value__unit">{{ part.unitKey | translate }}</span></span
      >
    }
  </p>
  @if (delta() !== null) {
    <app-monitoring-delta
      [percent]="delta() ?? 0"
      [lowerIsBetter]="true"
      [progress]="progress()"
      [previousFrom]="previousFrom()"
    />
  }
</div>
